<script setup>
/*
    Display an Icon input widget.

    Components:
        primary: <v-btn>

    Widget Properties:
        text: $robot

    Component Args

    CSS Properties:
        background
        color
        border-*
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); # drop shadow
        --w-variant | Set to elevated, flat, tonal, outlined, text or plain
        --w-block | Set to true to make the button full width
        --w-density | Set to compact, default or comfortable
        --w-ripple | Set to enable the ripple effect
        ...

    Examples:
        prefix: $robot
 */

import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({click, update})

const props = defineProps({
    loading: Boolean,
    widget: Object,
})

const page = reactive({
    args: {},
    data: {},
    icon: false,
})

const primary = ref(null)
// These are virtual elements that pass widget.prefix & suffix 
const prefix = ref(null)
const suffix = ref(null)

const DefaultStyles = {
    prefix: {},
    primary: {
        'background': 'rgb(var(--v-theme-primary))',
        'color': 'rgb(var(--v-theme-on-primary))',
        'font-size': 'max(10px, min(min(9cqw, 20cqh), 144px))',
        'font-weight': 'bold',
    },
    suffix: {},
}

async function update() {
    let widget = props.widget
    Object.assign(page, getWidgetProps(widget, 
        {primary, prefix, suffix},
        {args: {variant: 'flat'}, styles: DefaultStyles},
    ))
    let {args, styles} = page
    if (args.variant == 'outlined' || args.variant == 'text') {
        // Remove button color
        primary.value.$el.style.background = ''
    }
    if (styles.color && !args.color) {
        // Need to map color to the vuetify v-btn color arg
        args.color = styles.background
    }
}

function click() {}
</script>

<template>
    <v-btn ref="primary" class="icon-widget" :icon="page.data.primary" v-bind="page.args" />
</template>

<style lang="scss" scoped>
.icon-widget {
    container-type: size;
    position: relative;
    height: min(100cqh, 100cqw) !important;
    width: min(100cqh, 100cqw) !important;
    text-align: center;
    top: 50cqh;
    transform: translateY(-50%);
}
</style>
